import { useState } from 'react';
import axios from 'axios';
import { AUTH_ENDPOINTS } from '../constants/api';

interface UseEmailVerificationResult {
  resendVerification: () => Promise<void>;
  isResending: boolean;
  message: { type: 'success' | 'error'; text: string } | null;
  clearMessage: () => void;
}

export const useEmailVerification = (): UseEmailVerificationResult => {
  const [isResending, setIsResending] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error'; text: string } | null>(null);

  const resendVerification = async () => {
    setIsResending(true);
    setMessage(null);

    try {
      const token = sessionStorage.getItem('token');
      const response = await axios.post(
        AUTH_ENDPOINTS.RESEND_VERIFICATION,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setMessage({ 
        type: 'success', 
        text: response.data.message || 'Verification email sent!' 
      });
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Failed to resend verification email.';
      setMessage({ type: 'error', text: errorMessage });
    } finally {
      setIsResending(false);
    }
  };

  const clearMessage = () => {
    setMessage(null);
  };

  return {
    resendVerification,
    isResending,
    message,
    clearMessage,
  };
};
